import { combineReducers } from "redux";
import authReducer from "../reducers/authAction/index";
import dashboardReducer from "../reducers/dashboard/index";

const rootReducer = combineReducers({
  authReducer,
  dashboardReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
